/**
 * 对应二级节点
 */

import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';
import { useMemo } from 'react';
import ConnectionLineStore from '@/components/chat-history/connection-line/store';

const statusIcon = {
  running : "https://p2.ssl.qhimg.com/t11098f6bcd187518169bb48533.png",
  success : "https://p5.ssl.qhimg.com/t11098f6bcd76cad5ba2dc6476d.png",
  waiting : "https://p1.ssl.qhimg.com/t11098f6bcddb090a946a3b702b.png",
}

const McpToolsFolder = observer((props) => {
  const {
    className = '',
    title = '',
    subTitle = '',
    event,
    children,
    index = 0,
    mcpStore,
    isAITyping,
  } = props;

  const [folded, setFolded] = useState(false);
  const toggleFolded = (event) => {
    event.stopPropagation();
    setFolded(v => !v);
    // 延迟，确保dom已经渲染或移除
    setTimeout(() => {
      const id = `${mcpStore.panelMessageId || ''}_${mcpStore.currentPanelId || ''}`;
      ConnectionLineStore.updatePoint(id);
    }, 0);
  }

  // 没有 title 的，不显示二级节点
  const hideLevel2 = !title;
  const hasChildren = event.children?.length;

  // 三级节点状态
  const childrenStatus = useMemo(() => {
    // debug
    // return "running";

    const children = event.children;
    if(!children?.length){
      return "waiting";
    }

    const status = children.some(event => ["running"].includes(event.status)) ? "running" : "success";

    // 消息已输出完，但未完成的节点
    if(status == "running" && !isAITyping){
      return "waiting";
    }

    return status;
  }, [event, isAITyping]);

  // 工作流 Agent 中，出现了只有二级，没有三级的情况
  if(!hasChildren && mcpStore.isAgentFlow){
    return null;
  }

  return (
    <div className={`tools-folder ${hideLevel2 ? "tools-folder-hidden" : ""} ${className}`} data-id={event?.planStepId}>
      {
        hideLevel2
        ? null
        : (
          <div 
            className={`flex select-none w-full ${hasChildren ? 'cursor-pointer' : ''}`}
            onClick={toggleFolded}
            >
            <div className="flex w-40px h-36px justify-center items-center">
              <div
                className={`size-16px bg-white absolute rounded-full ${childrenStatus == "running" ? 'ani-rotate animate-ease-in-out' : ''}`} >
                <SVGPureIcon name={`mcp_level2_${childrenStatus}`} className='text-black' />
              </div>
            </div>
            <div className="text-14px leading-20px mr-10px w-0 flex-grow py-8px">
              {HelperCore.getFixedSuffix0(index + 1, 2)}&nbsp;{title}
            </div>
            {
              hasChildren
              ? (
                <div className={`size-16px mt-10px transition-transform transition-[0.25s] transform flex items-center justify-center ${folded ? 'rotate-[180deg]' : ''}`}>
                  <SVGPureIcon className='size-12px' name="mcp_left_card_fold" />
                </div>
              )
              : null
            }
          </div>
        )
      }
      {
        !folded && hasChildren
        ? (
          <div className={`${hideLevel2 ? "" : "mt-4px"} ${hideLevel2 ? '' : 'pl-40px'}`}>
            {
              subTitle
              ? (
                <div className="pl-28px text-14px leading-18px text-black text-opacity-60">
                  {subTitle}
                </div>
              )
              : null
            }
            {children}
          </div>
        )
        : null
      }
    </div>
  )
});
export default McpToolsFolder;